import { MaskedLines } from "./Reveal";
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, titleLines, intro }) {
  return (
    <header className="relative bg-ink-900 text-paper grain pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden" data-testid="page-header">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[45vw] h-[45vw] rounded-full bg-gold/10 blur-[120px]" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.span
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
          className="label-mono text-gold"
        >
          {eyebrow}
        </motion.span>
        <MaskedLines
          lines={titleLines}
          delay={0.15}
          className="font-display font-semibold text-5xl sm:text-6xl lg:text-8xl leading-[0.9] mt-6 tracking-tight"
        />
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }}
            className="max-w-2xl mt-8 text-lg text-paper/70"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </header>
  );
}
